<template>
  <div class="dem-imp-xml">
    <!-- APRESENTA A OPÇÃO CARREGANDO NA TELA -->
    <RF-Status v-if='statusGeral !== ""' :cpntStatus='statusGeral' :cpntTamanho='5'></RF-Status>
    
    <!-- APRESENTA O CONTEUDO DA TELA -->
    <template v-else-if='statusGeral === ""'>
      <template v-if="Object.keys(arquivos).length >= 1 && envio !== null">

        <RF-Dialog v-if="envio === 'log'"
        :cpntLargura='"800px"'
        :cpntStatus="''"
        :cpntOnFecharDialog='demImpXmlFecharImportacao'>
        <template slot='titulo'>
          <svg aria-hidden="true" class="fa fa-angle-double-right"></svg>
          <span class="titulo">
            Importação de 
            <template v-if="acao === 'contato'">Contato</template>
            <template v-else-if="acao === 'produto'">Produto</template>
            <template v-else-if="acao === 'dem_compra'">Compra</template>
            <template v-else-if="acao === 'dem_venda'">Venda</template>
            dos XMLs solicitados.
          </span>
          <span style="text-align: center;">&nbsp;(Logs de comunicação)</span>
        </template>

        <template slot='conteudo'>
          <template v-for="(file, indexA) in arquivos">
            <App-Demanda-Importar-Xml-Logs :key="'log--' + indexA" v-if="file.logs !== null"
            :cpntFileName="file.filename"
            :cpntLogs="file.logs"
            ></App-Demanda-Importar-Xml-Logs>
          </template>
        </template>
        </RF-Dialog>


        <!-- SETA O CABEÇALHO DE AÇÃO -->
        <div class="dem-imp-xml-cab">
          <div class="dem-imp-xml-cab-opcoes">
            <!-- SETA O TITULO DO CAMPO -->
            <div class="titulo">
              Como deseja importar {{ Object.keys(arquivos).length >= 2 ? 'esses xmls' : 'esse xml' }}?
            </div>
            
            <!-- SETA AS OPÇÕES -->
            <div class="opcao">
              <App-Button :cpntDisabled="envio === 'carregando'" @onClick="() => { acao = 'contato' }" :cpntClass="[ 'btn', 'btn-default' ]" :class="acao === 'contato' ? 'btn-primary' : ''">Contato</App-Button>
              <App-Button :cpntDisabled="envio === 'carregando'" @onClick="() => { acao = 'produto' }" :cpntClass="[ 'btn', 'btn-default' ]" :class="acao === 'produto' ? 'btn-primary' : ''">Produto</App-Button>
              <App-Button :cpntDisabled="envio === 'carregando'" @onClick="() => { acao = 'dem_compra' }" :cpntClass="[ 'btn', 'btn-default' ]" :class="acao === 'dem_compra' ? 'btn-primary' : ''">Compra</App-Button>
              <!-- <App-Button :cpntDisabled="envio === 'carregando'" @onClick="() => { acao = 'dem_venda' }" :cpntClass="[ 'btn', 'btn-default' ]" :class="acao === 'dem_venda' ? 'btn-primary' : ''">Venda</App-Button> -->
            </div>
          </div>

          <!-- SETA OS BOTOES -->
          <div class="dem-imp-xml-cab-botoes">
            <!-- SETA O BOTÃO IMPORTAR -->
            <App-Button :cpntStatus="envio" @onClick="demImpXmlRealizarImportacao" :cpntClass="[ 'btn', 'btn-primary' ]">Importar</App-Button>
            
            <!-- SETA O BOTÃO CANCELAR -->
            <App-Button :cpntDisabled="envio === 'carregando'" @onClick="demImpXmlRealizarCancelamento" :cpntClass="[ 'btn', 'btn-default', 'btn-sm' ]">Cancelar</App-Button>
          </div>
        </div>

        <!-- RODA O FOR NOS ARQUIVOS -->
        <template v-for="(file, indexA) in arquivos">
          <App-Demanda-Importar-Xml-Dados :key="'xml2--' + indexA" v-show="[ 'dem_compra', 'dem_venda' ].indexOf(acao) !== -1"
          :cpntIndexFile="indexA"
          :cpntAcao="acao"
          :cpntFileName="file.filename"
          :cpntFileConteudo="file.conteudo"
          :cpntPreAnalise="file.pre_analise"
          :cpntTratarTagsContato="demImpXmlTratarTagsContato"
          :cpntQRCode="indexA"
          ref="xmls"
          ></App-Demanda-Importar-Xml-Dados>
        </template>

        <App-Demanda-Importar-Xml-Separado v-if="envio !== 'log' && [ 'contato', 'produto' ].indexOf(acao) !== -1"
        :cpntAcao="acao"
        :cpntArquivos="arquivos"
        :cpntTratarTagsContato="demImpXmlTratarTagsContato"
        ref="separados"
        ></App-Demanda-Importar-Xml-Separado>
      </template>

      <template v-else>
        <div class="titulo">
          Importar dados dos documentos fiscais no formato XML
        </div>

        <div class="drop" v-if="arquivos">
          <div ref="drop_area" class="noselect" :class="seletor.class">
            <div v-if="envio !== null">
              <template v-if="envio === 'validando'">
                Estamos validando o arquivo recebido.
              </template>
              <template v-else>
                Estamos processando o(s) arquivo(s).
              </template>
              <br/>
              <br/>
              Por favor aguarde só mais alguns instantes...
            </div>

            <!-- SETA O TITULO DO CAMPO -->
            <div class="titulo" v-show="envio === null">
              <span>Importação XML</span>
              <br/>
              <br/>
              Selecione ou arraste nesta área um arquivo com a extensão .xml
              <br/>
              <br/>
            </div>

            <!-- SETA A OPÇÃO PARA ESCOLHER UM ARQUIVO -->
            <span v-show="envio === null">
              <input :id='seletor.id + "-input"' name="files[]" accept=".xml,.XML,.Xml" :disabled="seletor.disabled" :value="seletor.value" :multiple="true" type="file" @change="seletor.onChange"/>
              <label :for='seletor.id + "-input"'><strong>Escolha um arquivo</strong><span> ou arraste-o aqui</span>.</label>
            </span>
          </div>
        </div>
      </template>
    </template>
  </div>
</template>

<style scoped>
.dem-imp-xml {
  margin-top: 30px;
}
  .dem-imp-xml > .titulo {
    text-align: center;
    font-weight: bold;
    font-size: 18px;
    margin-bottom: 10px;
  }

.dem-imp-xml > .drop {
  max-height: 250px;
  min-height: 250px;
}
.dem-imp-xml > .drop {
  width: 600px;
  height: 200px;
  margin: 0px auto;
}
  .dem-imp-xml > .drop > div > .titulo {
    font-size: calc(100% + 1px);
  }
    .dem-imp-xml > .drop > div > .titulo > span {
      font-weight: bold;
      text-decoration: underline;
      text-transform: uppercase
    }
  .dem-imp-xml > .drop > .dem-imp-xml-box-upload {
    width: 600px;
    height: 200px;
    display: table-cell;
    vertical-align: middle;
    border-radius: 5px;

    outline: 2px dashed #92b0b3;
    outline-offset: -10px;
    -webkit-transition: outline-offset .15s ease-in-out, background-color .15s linear;
    transition: outline-offset .15s ease-in-out, background-color .15s linear;
    transition: all 0.3s ease-in-out;

    background-color: #c8dadf;
    padding: 30px 20px;
    text-align: center;
  }
    .dem-imp-xml > .drop > .dem-imp-xml-box-upload > span > input {
      width: 0.1px;
      height: 0.1px;
      opacity: 0;
      overflow: hidden;
      position: absolute;
      z-index: -1;
    }
      .dem-imp-xml > .drop > .dem-imp-xml-box-upload > span > label {
        cursor: pointer;
        color: #0f3c4b;
        font-size: var(--font-base-soma-15);
      }
      .dem-imp-xml > .drop > .dem-imp-xml-box-upload > span > input:disabled ~ label {
        cursor: no-drop;
      }
      .dem-imp-xml > .drop > .dem-imp-xml-box-upload > span > label:hover strong {
        color: #39bfd3;
        font-weight: bold;
      }
  .dem-imp-xml > .drop > .dem-imp-xml-box-upload-dragover {
    outline-offset: -20px;
    outline-color: #c8dadf;
    background-color: #f9f9f9;
  }

  .dem-imp-xml > .dem-imp-xml-cab {
    width: 600px;
    margin: 0px auto;
  }
    .dem-imp-xml > .dem-imp-xml-cab > .dem-imp-xml-cab-botoes {
      width: 100px;
      display: inline-block;
      background: #f9f9f9;
      border: 1px solid #e9e9e9;
      padding: 5px;
      border-radius: 5px;
      vertical-align: top;
    }
      .dem-imp-xml > .dem-imp-xml-cab > .dem-imp-xml-cab-botoes > button {
        width: 100%;
        margin: 3px 0px;
      }
    .dem-imp-xml > .dem-imp-xml-cab > .dem-imp-xml-cab-opcoes {
      width: calc(100% - 100px - 10px);
      display: inline-block;
      margin-right: 10px;
      background: #f9f9f9;
      border: 1px solid #e9e9e9;
      padding: 10px;
      border-radius: 5px;
      vertical-align: top;
    }
      .dem-imp-xml > .dem-imp-xml-cab > .dem-imp-xml-cab-opcoes > .titulo {
        font-weight: bold;
        text-align: center;
        margin-bottom: 8px;
      }
      .dem-imp-xml > .dem-imp-xml-cab > .dem-imp-xml-cab-opcoes > .opcao {
        text-align: center;
      }
        .dem-imp-xml > .dem-imp-xml-cab > .dem-imp-xml-cab-opcoes > .opcao > button {
          width: calc((100% / 4) - 6px);
          margin: 3px
        }
</style>

<script>
// IMPORTA A FUNÇÃO UTILIZADA
import { PEGAR_VALOR_CHAVE_XML } from '@/assets/js/Funcoes-Gerais.js'

export default {
  props: {
    cpntIdDfReceibo: {
      type: Array,
      required: false,
      default: function () {
        return []
      }
    }
  },
  components: {
    'App-Demanda-Importar-Xml-Dados': () => import('./Demanda-Importar-Xml-Dados'),
    'App-Demanda-Importar-Xml-Separado': () => import('./Demanda-Importar-Xml-Separado'),
    'App-Demanda-Importar-Xml-Logs': () => import('./Demanda-Importar-Xml-Logs')
  },
  data: function () {
    return {
      time: '',
      statusGeral: 'carregando',
      envio: null,
      arquivos: [],
      acao: 'dem_compra',
      seletor: {
        id: 'dem-imp-xml',
        class: 'dem-imp-xml-box-upload',
        value: '',
        qrcode: '',
        disabled: false,
        onChange: this.appDemImportarOnChangeInput
      },
      validado: true
    }
  },
  mounted: function () {
    // SETA O STATUS DA PAGINA
    this.appDemImportarSetarStatusGeral('carregando')

    // INICIA O CARREGAMENTO DA TELA
    this.appDemImportarBuscarXmlArmArquivo()
  },
  methods: {
    appDemImportarSeletorObservadorIniciar: function (tentativa = 0) {
      if (tentativa <= 10) {
        setTimeout(() => {
          if ([ '', null, undefined ].indexOf(this.$refs) !== -1 || [ '', null, undefined ].indexOf(this.$refs.drop_area) !== -1) {
            this.appDemImportarSeletorObservadorIniciar((tentativa + 1))
          } else {
            var funcao = (force = false, requestId = '') => {
              if (force === true || this.seletor.requestId === requestId) {
                // SETA A CLASSE DO CAMPO
                this.seletor.class = [ 'dem-imp-xml-box-upload' ]

                // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
                this.time = new Date().getTime()
              }
            }

            // ADICIONA O EVENTO AO COLOCAR UM ARQUIVO SOBRE O CAMPO
            $(this.$refs.drop_area).on('dragover', (event) => {
              // PARA A AÇÃO DO EVENTO
              event.stopPropagation()
              event.preventDefault()

              // SETA O REQUEST ID
              var flag = Math.floor(Math.random() * (9999 - 1000)) + 1000

              // SETA O ID GERADO
              this.seletor.requestId = flag

              // SETA A CLASSE DO CAMPO
              this.seletor.class = [ 'dem-imp-xml-box-upload', 'dem-imp-xml-box-upload-dragover' ]

              // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
              this.time = new Date().getTime()

              // CHAMA A FUNÇÃO PARA LIMPAR O STATUS APÓS 200MS
              setTimeout(function () { funcao(false, flag) }, 200)
            })

            // ADICIONA O EVENTO AO TIRAR UM ARQUIVO SOBRE O CAMPO
            $(this.$refs.drop_area).on('dragenter', (event) => {
              // PARA A AÇÃO DO EVENTO
              event.stopPropagation()
              event.preventDefault()

              // CHAMA A FUNÇÃO PARA LIMPAR O STATUS
              funcao(true)
            })

            // ADICIONA O EVENTO AO TIRAR UM ARQUIVO SOBRE O CAMPO
            $(this.$refs.drop_area).on('drop', (event) => {
              // PARA A AÇÃO DO EVENTO
              event.stopPropagation()
              event.preventDefault()

              // DESABILITA O INPUT PARA INSERIR NOVO
              this.seletor.disabled = true

              // LIMPA O STATUS PARA PARAR O PROCESSO
              this.seletor.requestId = ''

              // INICIAR O INPUT QUE RECEBE OS ARQUIVOS
              this.seletor.value = []

              // // SETA OS ARQUIVOS RECEBIDOS
              // this.seletor.value = event.originalEvent.dataTransfer.files

              // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
              this.time = new Date().getTime()

              // PEGA OS ARQUIVOS
              var files = Array.prototype.slice.call(event.originalEvent.dataTransfer.files)

              // INICIA O PROCESSAMENTO DOS ARQUIVOS
              this.appDemImportarArquivoLer(files)

              // CHAMA A FUNÇÃO PARA VERIFICA OS DADOS DO SELETOR
              this.appDemImportarVerificarStatusSeletor()
            })

            // SETA O STATUS DA PAGINA
            this.appDemImportarSetarStatusGeral('')
          }
        }, tentativa === 0 ? 1 : 200)
      }
    },
    appDemImportarBuscarXmlArmArquivo: function () {
      if ([ '', null, undefined ].indexOf(this.cpntIdDfReceibo) !== -1 || Array.isArray(this.cpntIdDfReceibo) === false || this.cpntIdDfReceibo.length === 0) {
        // SETA O STATUS DA PAGINA
        this.appDemImportarSetarStatusGeral('')

        // MANDA CRIAR OS OBSERVADORES
        this.appDemImportarSeletorObservadorIniciar()
      } else {
        // DESABILITA O INPUT PARA INSERIR NOVO
        this.seletor.disabled = true

        // INICIAR O INPUT QUE RECEBE OS ARQUIVOS
        this.seletor.value = []

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()

        // INICIA O QUERYGET
        var queryGet = { type: 'list', limit: { row: 0, qty: 1000 }, field: { id: null, filename: null, ext: null, size_bytes_thumbnail: null, last_at: null }, order: {} }

        // SETA O WHERE
        queryGet.where = { aAnd: [ { f: 'status', o: '=', v: '1' }, { f: 'id_doc_fis_distribuir', o: '=', v: this.cpntIdDfReceibo.join() } ] }

        // SETA A ORDENAÇÃO
        queryGet.order.last_at = 'asc'

        // FAZ A BUSCA NA API
        this.$store.state.comunicaAPI('/arm-arquivo/get/', 'GET', queryGet, (retorno) => {
          // INICIA O QUERYGET
          var queryGet = { lot: [ ] }

          // ADICIONA OS IDS RECEBIDOS
          for (var indexR in retorno.data) {
            queryGet.lot.push({ id: retorno.data[indexR].id, tipo: [ 'conteudo_b64' ] })
          }

          // FAZ A BUSCA NA API
          this.$store.state.comunicaAPI('/arm-arquivo/arquivo/get/', 'GET', queryGet, (retorno) => {
            // TRATA OS RETORNOS RECEBIDOS
            for (var indexL in retorno.lot) {
              if (retorno.lot[indexL].code === '200') {
                // INICIA A CHAVE DO VETOR
                var chave = ('file--' + indexL)
      
                // ADICIONA O ARQUIVO RECEBIDO
                this.arquivos[chave] = { df_recebido: retorno.lot[indexL].data.id_doc_fis_distribuir, filename: retorno.lot[indexL].data.filename, conteudo: window.atob(retorno.lot[indexL].data.conteudo_b64), logs: null }
              } else {
                this.$store.state.msgWarn('API [' + retorno.lot[indexL].code + ']: ' + retorno.lot[indexL].message, 'danger')
              }
            }

            if (Object.keys(this.arquivos).length === 0) {
              this.demImpXmlRealizarCancelamento()
            } else {
              // SETA O STATUS DA PAGINA
              this.appDemImportarSetarStatusGeral('carregando')
      
              // CHAMA A FUNÇÃO PARA SALVAR OS ARQUIVOS
              this.appDemImportarSalvarArquivos()
            }
          }, this.appDemImportarSetarStatusGeral, null)
        }, this.appDemImportarSetarStatusGeral)
      }
    },
    appDemImportarSetarStatusGeral: function (status) {
      // SETA O STATUS DA TELA
      this.statusGeral = status

      // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
      this.time = new Date().getTime()
    },
    appDemImportarOnChangeInput: function (event) {
      // LIMPA OS DADOS DO INPUT
      this.seletor.value = ''

      // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
      this.time = new Date().getTime()

      // PEGA O ARQUIVO
      var arquivo = [ '', null, undefined ].indexOf(event.clipboardData) === -1 ? event.clipboardData : event.target

      // VERIFICA SE TEM ALGUM ARQUIVO PARA SALVAR
      if (arquivo.files.length >= 1) {
        // DESABILITA O INPUT PARA INSERIR NOVO
        this.seletor.disabled = true

        // INICIAR O INPUT QUE RECEBE OS ARQUIVOS
        this.seletor.value = []

        // // SETA OS ARQUIVOS RECEBIDOS
        // this.seletor.value = arquivo.files

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
        
        // PEGA OS ARQUIVOS
        var files = Array.prototype.slice.call(arquivo.files)

        // INICIA O PROCESSAMENTO DOS ARQUIVOS
        this.appDemImportarArquivoLer(files)
      }

      // CHAMA A FUNÇÃO PARA VERIFICA OS DADOS DO SELETOR
      this.appDemImportarVerificarStatusSeletor()
    },
    appDemImportarVerificarStatusSeletor: function () {
      // VERIFICA SE TEM ALGUM ARQUIVO SELECIONADO
      this.seletor.disabled = this.envio !== null
      
      // VERIFICA O STATUS DO CAMPO
      switch (this.seletor.disabled) {
        case true:
          // SETA A CLASSE DO CAMPO
          this.seletor.class = [ 'dem-imp-xml-box-upload', 'dem-imp-xml-box-upload-dragover' ]
          break

        case false:
          // SETA A CLASSE DO CAMPO
          this.seletor.class = [ 'dem-imp-xml-box-upload' ]
          break
      }

      // INICIAR O INPUT QUE RECEBE OS ARQUIVOS
      this.seletor.value = []

      // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
      this.time = new Date().getTime()
    },
    appDemImportarSalvarArquivos: function () {
      // SETA O STATUS DA PAGINA
      this.appDemImportarSetarStatusGeral('carregando')

      // INICIA O VETOR
      var formData = []

      // ADICIONA OS ARQUIVOS AO VETOR
      for (var indexA in this.arquivos) {
        formData.push({ ref_virtual: indexA, j_conteudo: JSON.stringify({ filename: this.arquivos[indexA].filename, conteudo: this.arquivos[indexA].conteudo }) })
      }

      // CONVERTE O VETOR EM LOT
      formData = { lot: formData }

      // CHAMA FUNÇÃO PARA COMUNICAR COM API
      this.$store.state.comunicaAPI('/subase/qrcode2', 'POST', formData, (retorno) => {
        // INICIA O VETOR
        var files = {}

        // SETA O ID RECEBIDO EM TODOS OS ARQUIVOS
        for (var indexR in retorno.lot) {
          // PEGA O NOME DA CHAVE
          var indexV = retorno.lot[indexR].ref.qrcode

          // SETA OS DADOS RECEBIDOS
          files[indexV] = Object.assign(this.arquivos[retorno.lot[indexR].ref.ref_virtual], { qrcode: retorno.lot[indexR].ref.qrcode })
        }
        
        // ATUALIZA OS ARQUIVOS
        this.arquivos = files

        // CHAMA A FUNÇÃO PARA BUSCAR AS REFERENCIAS DOS PRODUTOS
        this.appDemImportarProcessarArquivos()
      }, this.appDemImportarSetarStatusGeral)
    },
    appDemImportarProcessarArquivos: function () {
      // PEGA OS IDS DOS QRCODES ENCONTRADOS
      var queryGet = { qrcode: JSON.stringify(Object.keys(this.arquivos)) }

      // CHAMA FUNÇÃO PARA COMUNICAR COM API
      this.$store.state.comunicaAPI('/config/importar/xml-dados/pre-importar/get', 'POST', queryGet, (retorno) => {
        // REMOVE A CHAVE LOT
        retorno = retorno.lot

        // TRATA OS VALORES RECEBIDOS
        for (var indexL in retorno) {
          if (retorno[indexL].code === '200') {
            // PEGA O NOME DA CHAVE DO VETOR
            var chaveV = retorno[indexL].ref.qrcode

            // SETA OS DADOS RECEBIDOS NO VETOR SOLICITADO
            this.arquivos[chaveV].pre_analise = retorno[indexL].data
          } else {
            this.$store.state.msgWarn('API [' + retorno[indexL].code + ']: ' + retorno[indexL].message, 'danger')
          }
        }

        // SETA O STATUS DA TELA
        this.envio = ''

        // SETA O STATUS DA PAGINA
        this.appDemImportarSetarStatusGeral('')
      }, this.appDemImportarSetarStatusGeral)
    },
    appDemImportarArquivoLer: function (files, index = 0) {
      // SETA A VARIAVEL DE LIMITE
      var limite = 200

      // VERIFICA SE ULTRAPASSOU O LIMITE
      if (files.length > limite) {
        // APRESENTA A MENSAGEM DE ERRO
        this.$store.state.msgWarn('WEB [406]: Só é possivel enviar até (' + limite + ') arquivos por vez, você está tentando enviar (' + files.length + ') arquivos.', 'warning')

        // REALIZA O CANCELAMENTO DA TELA
        this.demImpXmlRealizarCancelamento()
      } else {
        // PEGA O ARQUIVO QUE ESTÁ PROCESSANDO
        var file = files[index]
  
        // SETA O VALOR RECEBIDO
        this.envio = 'validando'
  
        // INICIA A LEITURA DO ARQUIVO
        var reader = new FileReader()
  
        // VERIFICA SE TEM ARQUIVO 
        if ([ '', null, undefined ].indexOf(file) !== -1) {
          // SETA O STATUS DA PAGINA
          this.appDemImportarSetarStatusGeral('carregando')
  
          // CHAMA A FUNÇÃO PARA SALVAR OS ARQUIVOS
          this.appDemImportarSalvarArquivos()
        } else {
          // SETA FUNÇÃO DE SUCESSO DE LEITURA
          reader.onload = () => {
            // INICIA A CHAVE DO VETOR
            var chave = ('file--' + index)
  
            // ADICIONA O ARQUIVO RECEBIDO
            this.arquivos[chave] = { filename: file.name, conteudo: reader.result, logs: null }
  
            // REINICIA O PROCESSO
            this.appDemImportarArquivoLer(files, (index + 1))
          }
    
          // FAZ A LEITURA DO ARQUIVO RECEBIDO
          reader.readAsText(file, 'utf8')
        }
      }
    },
    demImpXmlRealizarCancelamento: function () {
      // SETA O STATUS DA PAGINA
      this.appDemImportarSetarStatusGeral('carregando')

      // LIMPA A VARIAVEL DE ENVIO
      this.envio = null

      // LIMPA OS ARQUIVOS SALVOS NO VETOR
      this.arquivos = []

      // SETA A AÇÃO INICIAL
      this.acao = 'dem_compra'

      // CHAMA A FUNÇÃO PARA VERIFICA OS DADOS DO SELETOR
      this.appDemImportarVerificarStatusSeletor()

      // VERIFICA SE TEM QUE ATUALIZAR A ROTA VUE
      if (this.$route.name !== 'config_importar_xml') {
        // MUDA A ROTA PARA NÃO DAR PROBLEMA AO REALIZAR F5
        this.$router.push({ name: 'config_importar_xml' })

        // INICIA O CARREGAMENTO DA TELA NOVAMENTE
        setTimeout(() => { this.appDemImportarBuscarXmlArmArquivo() }, 500)
      } else {
        // SETA O STATUS DA PAGINA
        this.appDemImportarSetarStatusGeral('')

        // MANDA CRIAR OS OBSERVADORES
        this.appDemImportarSeletorObservadorIniciar()
      }
    },
    demImpXmlFecharImportacao: function () {
      // REMOVE TODOS OS ARQUIVOS QUE DEU CERTO A IMPORTAÇÃO
      for (var index in this.arquivos) {
        if ([ '', null, undefined ].indexOf(this.arquivos[index].logs) === -1 && [ '', null, undefined ].indexOf(this.arquivos[index].logs.code) === -1 && this.arquivos[index].logs.code === '200') {
          delete this.arquivos[index]
        }
      }
      
      // VERIFICA SE DEVE FECHAR A TELA OU FECHAR APENAS O LOG
      if (Object.keys(this.arquivos).length <= 0) {
        this.demImpXmlRealizarCancelamento()
      } else {
        // LIMPA A VARIAVEL
        this.envio = ''

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      }
    },
    demImpXmlMontarValorItemDividido: function (dividido, ref) {
      // INICIA A VARIAVEL
      var itens = []
      var item = {}

      // PEGA A QUANTIDADE DE DIVISOES DESTE ITEM
      var qtdeD = typeof ref.dividir.value === 'string' ? ref.dividir.value : ref.dividir.value.valor

      // VERIFICA SE TEM UMA DIVISÃO VALIDA
      if ([ '', null, undefined ].indexOf(qtdeD) !== -1) {
        // SETA A MENSAGEM DE ERRO
        ref.dividir.mensagem = 'É necessario selecionar a quantidade de divisões que esse produto terá para continuar'
  
        // REALIZA O FOCUS DO CAMPO
        if (this.validado === true) {
          ref.$refs.dividir.cpntRealizarFocus()
        }

        // ALTERA A VARIAVEL DE VALIDAÇÃO
        this.validado = false
      } else {
        // RODA O VETOR ADICIONANDO OS VALORES
        for (var indexD in dividido) {
          // LIMPA A VARIAVEL
          item = { id_pro: '' }
  
          // VERIFICA SE TEM PRODUTO SELECIONADO
          if ([ '', null, undefined ].indexOf(dividido[indexD].id_pro) === -1) {
            item.id_pro = dividido[indexD].id_pro
          } else if ([ '', null, undefined ].indexOf(dividido[indexD]._busca) === -1 && (item.id_pro === '' || dividido[indexD].id_pro_nome !== dividido[indexD]._busca)) {
            item.nome = dividido[indexD]._busca
          }
          // SETA O STATUS DO CAMPO
          if ([ '', null, undefined ].indexOf(item.id_pro) !== -1 && [ '', null, undefined ].indexOf(item.nome) !== -1) {
            // SETA A MENSAGEM DE ERRO
            ref.linhas[indexD].produto_mensagem = 'É necessario preencher o nome do produto ou selecionar um produto para continuar'
  
            // REALIZA O FOCUS DO CAMPO
            if (this.validado === true) {
              ref.$refs['produto--' + indexD].cpntRealizarFocus()
            }
  
            // ALTERA A VARIAVEL DE VALIDAÇÃO
            this.validado = false
          }
          
          // SETA O ID DO PRODUTO SELECIONADO
          item.qtde = dividido[indexD].qtde
  
          // SETA O STATUS DO CAMPO
          if ([ '', null, undefined ].indexOf(item.qtde) !== -1) {
            // SETA A MENSAGEM DE ERRO
            ref.linhas[indexD].qtde_mensagem = 'É necessario preencher uma quantidade para continuar'
  
            // REALIZA O FOCUS DO CAMPO
            if (this.validado === true) {
              ref.$refs['qtde--' + indexD].cpntRealizarFocus()
            }
  
            // ALTERA A VARIAVEL DE VALIDAÇÃO
            this.validado = false
          }
  
          // SETA O ID DO PRODUTO SELECIONADO
          if ([ '', null, undefined ].indexOf(dividido[indexD].cod_barra) === -1) {
            item.cod_barra = dividido[indexD].cod_barra
          }
  
          // ADICIONA O PRODUTO NO VETOR DA DEMANDA
          itens.push(item)
        }
      }
      
      // RETORNA O VALOR MONTADO
      return itens
    },
    demImpXmlMontarValorItem: function (vetor) {
      // INICIA A VARIAVEL ITEM
      var item = {}

      // VERIFICA SE O ITEM FOI ENCONTRADO
      switch (vetor._fundoN) {
        case 'background-tp-4': // VERDE
          if ([ '', null, undefined ].indexOf(vetor.produto.value) === -1 && [ '', null, undefined ].indexOf(vetor.produto.value.id_pro) === -1) {
            item.id_pro = vetor.produto.value.id_pro
          }
          break

        case 'background-tp-2': // AMARELO
        case 'background-tp-3': // VERMELHO
        default:
          // INICIA A VARIAVEL DO ID DO PRODUTO
          item.id_pro = ''

          // VERIFICA SE TEM PRODUTO SELECIONADO
          if ([ '', null, undefined ].indexOf(vetor.produto.value) === -1) {
            // VERIFICA SE TEM PRODUTO SELECIONADO
            if ([ '', null, undefined ].indexOf(vetor.produto.value.id_pro) === -1) {
              item.id_pro = vetor.produto.value.id_pro
            } else if ([ '', null, undefined ].indexOf(vetor.produto._busca) === -1 && (item.id_pro === '' || vetor.produto.value.id_pro_nome !== vetor.produto._busca)) {
              item.nome = vetor.produto._busca
            }
          }
          break
      }

      // RETORNA O VALOR 
      return item
    },
    demImpXmlRealizarImportacao: function () {
      // SETA O STATUS DO BOTÃO
      this.envio = 'carregando'

      // SETA O STATUS DO CAMPO
      this.validado = true

      // INICIA AS VARIAVEIS
      var formData = []
      var arquivo = {}
      var itens = []
      var indexI = ''
      var indexF = ''
      var demProduto = {}
      var dividido = ''

      // INICIA O ARQUIVO QUE ESTÁ SENDO PROCESSADO

      // VERIFICA A AÇÃO QUE ESTÁ SENDO FEITA
      if ([ 'produto' ].indexOf(this.acao) !== -1) {
        // PEGA AS LINHAS QUE DEVE PROCESSAR
        itens = this.$refs.separados.linhas

        // RODA O VETOR MONTANDO OS VALORES
        for (indexI in itens) {
          // PEGA O QRCODE DO ARQUIVO
          indexF = itens[indexI].indexArquivo

          // INICIA O VETOR DE PRODUTOS
          if (arquivo[indexF] === undefined) {
            // INICIA O VETOR
            arquivo[indexF] = {}

            // INICIA A CHAVE DEM_PRODUTO
            arquivo[indexF].dem_produto = {}

            // SETA O QRCODE DO ARQUIVO
            arquivo[indexF].qrcode = indexF

            // SETA O ID DO DF RECEBIDO
            if ([ '', null, undefined ].indexOf(this.arquivos[indexF].df_recebido) === -1) {
              arquivo[indexF].id_dfe_recebido = this.arquivos[indexF].df_recebido
            }
          }

          // INICIA A VARIAVEL ITEM
          demProduto = { item: [] }

          // PEGA O NOME DA UNIDADE COMERCIAL A UTILIZAR
          demProduto.tp_uni = this.$refs.separados.demImpXmlSeparadoUsarUnidade(indexI)

          // CONVERTE O VALOR RECEBIDO
          demProduto.tp_uni = (demProduto.tp_uni === 'trib' ? 'tributaria' : 'comercial')

          // VERIFICA SE EXISTE DIVISÃO DO PRODUTO
          if ([ '', null, undefined ].indexOf(this.$refs.separados.$refs['item--' + indexI]) === -1) {
            // PEGA OS VALORES DIVIDIDOS
            dividido = this.$refs.separados.$refs['item--' + indexI].linhas

            // ADICIONA O PRODUTO NO VETOR DA DEMANDA
            demProduto.item = demProduto.item.concat(this.demImpXmlMontarValorItemDividido(dividido))
          } else {
            // LIMPA A VARIAVEL
            item = this.demImpXmlMontarValorItem(itens[indexI])
            
            // SETA O ID DO PRODUTO SELECIONADO
            item.qtde = demProduto.tp_uni === 'tributaria' ? itens[indexI].qtde_trib : itens[indexI].qtde_com

            // ADICIONA O PRODUTO NO VETOR DA DEMANDA
            demProduto.item.push(item)
          }

          // SETA O VETOR MONTADO
          arquivo[indexF].dem_produto[itens[indexI].nItem] = demProduto
        }
        
        // ADICIONA O ARQUIVO NO VETOR FINAL
        formData = Object.values(arquivo)
      } else {
        // MONTA O VETOR DE ARQUIVO
        for (indexF in this.$refs.xmls) {
          // INICIA O ARQUIVO QUE ESTÁ SENDO PROCESSADO
          arquivo = {}
  
          // SETA O QRCODE DO ARQUIVO
          arquivo.qrcode = this.$refs.xmls[indexF].cpntQRCode

          // SETA O ID DO DF RECEBIDO
          if ([ '', null, undefined ].indexOf(this.arquivos[arquivo.qrcode].df_recebido) === -1) {
            arquivo.id_dfe_recebido = this.arquivos[arquivo.qrcode].df_recebido
          }
  
          // VERIFICA SE DEVE PEGAR OS ITENS
          if ([ 'dem_compra', 'dem_venda' ].indexOf(this.acao) !== -1 && [ '', null, undefined ].indexOf(this.$refs.xmls[indexF].$refs) === -1 && [ '', null, undefined ].indexOf(this.$refs.xmls[indexF].$refs.item) === -1) {
            // PEGA AS LINHAS DOS PRODUTOS ENCONTRADOS
            itens = this.$refs.xmls[indexF].$refs.item.linhas
  
            // INICIA O VETOR DE PRODUTOS
            arquivo.dem_produto = {}
  
            // RODA UM FOR MONTANDO OS VALORES
            for (indexI in itens) {
              // INICIA A VARIAVEL ITEM
              demProduto = { item: [] }
  
              // PEGA O NOME DA UNIDADE COMERCIAL A UTILIZAR
              demProduto.tp_uni = this.$refs.xmls[indexF].$refs.item.demImpXmlItensUsarUnidade(indexI)
  
              // CONVERTE O VALOR RECEBIDO
              demProduto.tp_uni = (demProduto.tp_uni === 'trib' ? 'tributaria' : 'comercial')
  
              // INICIA A VARIAVEL ITEM
              var item = {}
  
              // VERIFICA SE EXISTE DIVISÃO DO PRODUTO
              if ([ '', null, undefined ].indexOf(this.$refs.xmls[indexF].$refs.item.$refs) === -1 && [ '', null, undefined ].indexOf(this.$refs.xmls[indexF].$refs.item.$refs['item--' + indexI]) === -1) {
                // PEGA OS VALORES DIVIDIDOS
                dividido = this.$refs.xmls[indexF].$refs.item.$refs['item--' + indexI].linhas
  
                // ADICIONA O PRODUTO NO VETOR DA DEMANDA
                demProduto.item = demProduto.item.concat(this.demImpXmlMontarValorItemDividido(dividido, this.$refs.xmls[indexF].$refs.item.$refs['item--' + indexI]))
              } else {
                // LIMPA A VARIAVEL
                item = this.demImpXmlMontarValorItem(itens[indexI])                

                // SETA O ID DO PRODUTO SELECIONADO
                item.qtde = demProduto.tp_uni === 'tributaria' ? itens[indexI].qtde_trib : itens[indexI].qtde_com

                // ADICIONA O PRODUTO NO VETOR DA DEMANDA
                demProduto.item.push(item)
              }
  
              // SETA O VETOR MONTADO
              arquivo.dem_produto[itens[indexI].nItem] = demProduto
            }  
          }
  
          // ADICIONA O ARQUIVO NO VETOR FINAL
          formData.push(arquivo)
        }
      }

      // VERIFICA O STATUS DA VALIDAÇÃO
      if (this.validado === true) {
        // CONVERTE O VALOR EM LOT
        formData = { lot: formData }
  
        // SETA A AÇÃO QUE DEVE REALIZAR
        formData.acao = this.acao
  
        // FAZ A COMUNICAÇÃO COM A API
        this.$store.state.comunicaAPI('/config/importar/xml-dados', 'POST', formData, (retorno) => {
          // SETA O ID RECEBIDO EM TODOS OS ARQUIVOS
          for (var indexR in retorno.lot) {
            // PEGA O NOME DA CHAVE
            var indexV = retorno.lot[indexR].ref.qrcode
  
            // VERIFICA SE TEM A CHAVE DATA NO RETORNO
            if ([ '', null, undefined ].indexOf(retorno.lot[indexR].data) !== -1) {
              retorno.lot[indexR].data = [ retorno.lot[indexR] ]
            }
  
            // SETA OS DADOS RECEBIDOS
            this.arquivos[indexV].logs = retorno.lot[indexR]
          }
  
          // SETA O STATUS DA TELA
          this.envio = 'log'
  
          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          this.time = new Date().getTime()
        // }, this.appDemImportarSetarStatusGeral)
        }, () => {
          // SETA O STATUS DO BOTÃO
          this.envio = ''
  
          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          this.time = new Date().getTime()
        })
      } else {
        // SETA O STATUS DO BOTÃO
        this.envio = ''

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      }
    },
    demImpXmlTratarTagsContato: function (contato) {
      // INICIA A VARIAVEL
      var vetor = {}
      
      // VERIFICAR SE TEM VALOR PARA SER TRATADO
      if ([ '', null, undefined ].indexOf(contato) === -1) {
        // PEGA A CHAVE DOCUMENTO
        var pessoa = contato.getElementsByTagName('CPF').length >= 1 ? 'f' : 'j'
        
        // INICIA A VARIAVEL DOCUMENTO
        var documento = ''      
  
        // VERIFICA O CAMPO QUE DEVE REMOVE PARA CADA TIPO DE CASO
        switch (pessoa) {
          case 'f':
            // PEGA O VALOR DO CAMPO
            documento = PEGAR_VALOR_CHAVE_XML(contato, 'CPF')
  
            // FORMATA O VALOR RECEBIDO
            documento = documento.replace(/^(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4')
            break
          
          case 'j':
            // PEGA O VALOR DO CAMPO
            documento = PEGAR_VALOR_CHAVE_XML(contato, 'CNPJ')
  
            // FORMATA O VALOR RECEBIDO
            documento = documento.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5')
            break
        }
  
        // CONVERTE OS CAMPOS PARA O NOVO VETOR
        vetor.nome              = PEGAR_VALOR_CHAVE_XML(contato, 'xNome')
        vetor.empresa           = PEGAR_VALOR_CHAVE_XML(contato, 'xFant')
        vetor.cnpj_cpf          = documento
        vetor.ie                = PEGAR_VALOR_CHAVE_XML(contato, 'IE')
        vetor.tel_com           = PEGAR_VALOR_CHAVE_XML(contato, 'fone')
        vetor.end               = PEGAR_VALOR_CHAVE_XML(contato, 'xLgr')
        vetor.num               = PEGAR_VALOR_CHAVE_XML(contato, 'nro')
        vetor.comp              = PEGAR_VALOR_CHAVE_XML(contato, 'xCpl')
        vetor.bairro            = PEGAR_VALOR_CHAVE_XML(contato, 'xBairro')
        vetor.id_cidade_cidade  = PEGAR_VALOR_CHAVE_XML(contato, 'xMun')
        vetor.id_estado         = PEGAR_VALOR_CHAVE_XML(contato, 'UF')
        vetor.cep               = PEGAR_VALOR_CHAVE_XML(contato, 'CEP')
        vetor.pessoa            = pessoa
  
        // PEGA OUTRO CAMPO DE ENDEREÇO
        var xEnder = PEGAR_VALOR_CHAVE_XML(contato, 'xEnder')
  
        // VERIFICA SE TEM OUTRO CAMPO DE ENDEREÇO
        if ([ '', null, undefined ].indexOf(xEnder) === -1 && xEnder.indexOf(',') !== -1) {
          // FAZ A SEPARAÇÃO DA STRING
          xEnder = xEnder.split(',')
  
          // SETA O NUMERO DO ENDEREÇO
          vetor.num = xEnder[xEnder.length - 1]
  
          // REMOVE A ULTIMA PARTE DA STRING
          xEnder = xEnder.splice(xEnder.length - 2, 1)
  
          // SETA O NOME DA RUA
          vetor.end = xEnder.join(',')
  
          // VERIFICA SE AS CHAVES ESTÃO PREENCHIDAS
          if ([ '', null, undefined ].indexOf(vetor.cep) !== -1) {
            vetor.cep = '-'
          }
          if ([ '', null, undefined ].indexOf(vetor.num) !== -1) {
            vetor.num = '-'
          }
          if ([ '', null, undefined ].indexOf(vetor.comp) !== -1) {
            vetor.comp = '-'
          }
          if ([ '', null, undefined ].indexOf(vetor.bairro) !== -1) {
            vetor.bairro = '-'
          }
        }
      }

      // RETORNA O VALOR MONTADO
      return vetor
    }
  }
}
</script>
